import React from 'react';
import {
  ProgressBlock,
  CodeBlock,
  MetricsBlock,
  TableBlock,
  MarkdownBlock,
  SuggestionsBlock,
  ErrorBlock
} from './blocks';

// JSON fallback for unknown block types
const JsonBlock = ({ data }) => (
  <div className="border border-gray-200 rounded-lg overflow-hidden">
    <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
      <h4 className="font-medium text-gray-900">Raw Data</h4>
    </div>
    <pre className="bg-gray-50 p-4 overflow-auto text-sm">
      {JSON.stringify(data, null, 2)}
    </pre>
  </div>
);

// Block type registry
const blockRegistry = {
  progress: ProgressBlock,
  code: CodeBlock,
  metrics: MetricsBlock,
  table: TableBlock,
  markdown: MarkdownBlock,
  suggestions: SuggestionsBlock,
  error: ErrorBlock,
  json: JsonBlock,
};

// Main BlockRenderer component
const BlockRenderer = ({ block, onSuggestionClick }) => {
  const BlockComponent = blockRegistry[block.type];

  if (!BlockComponent) {
    console.warn(`Unknown block type: ${block.type}`);
    return <JsonBlock data={block.data} />;
  }

  return (
    <BlockComponent
      {...block.data}
      onSuggestionClick={block.type === 'suggestions' ? onSuggestionClick : undefined}
    />
  );
};

export default BlockRenderer;
